import hotToast from "react-hot-toast";

export const NotifyHelper = {
  //https://react-hot-toast.com/docs/toast
  /**
   * @param id Truyền id CỐ ĐỊNH cho các thông báo lặp lại liên tục (vd lưới tự lưu mỗi lần rời ô):
   *           react-hot-toast sẽ THAY thông báo cũ thay vì xếp chồng hàng chục cái.
   */
  Success: (message: string, id?: string) =>
    hotToast.success(message, id ? { id } : undefined),
  Error: (message?: string, id?: string) =>
    hotToast.error(message ?? "Error", id ? { id } : undefined),
  Warning: (message: string, id?: string) =>
    hotToast.error(message, id ? { id } : undefined),
};
